import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";

var Icon = function Icon(props) {
  return /*#__PURE__*/_jsx("svg", {
    className: "svg-icon ".concat(props.className ? props.className : ""),
    style: props.style,
    children: /*#__PURE__*/_jsx("use", {
      xlinkHref: "#".concat(props.icon)
    })
  });
};

export default Icon;